import { Link } from "react-router-dom";
import Logo from "../../assets/images/svg/logo/utivacolored.svg";
import { aboutMenuData } from "./data/aboutMenuData";
import { enterpriseMenuData, growData } from "./data/enterpriseMenuData";
import FixedWhatsappLink from "./FixedWhatsappLink";

const columns = [
  { title: "Company", items: aboutMenuData },
  { title: "Grow with Utiva", items: growData },
  { title: "Resources", items: enterpriseMenuData },
];

const SiteFooter = () => {
  return (
    <footer className="py-16 md:py-20 px-4" style={{ background: "#fdf2df" }}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div className="lg:col-span-1">
            <img className="h-7 w-auto mb-5" src={Logo} alt="Utiva" />
            <p className="text-gray font-poppins text-sm leading-relaxed max-w-xs mb-4">
              Practical learning, verified talent and global workforce
              infrastructure in one connected ecosystem.
            </p>
            <a
              href="mailto:info@utiva.io"
              className="font-poppins text-primary text-sm font-bold hover:text-secondary transition-colors block mb-2"
            >
              info@utiva.io
            </a>
            <p className="font-poppins text-gray text-sm">© 2026 Utiva</p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-poppins font-bold text-primary text-base mb-4">
                {column.title}
              </h3>
              <ul className="grid gap-3">
                {column.items.map((item) => (
                  <li key={item.id}>
                    {item.url?.includes("http") ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-poppins text-gray text-sm hover:text-primary transition-colors"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <Link
                        to={item.url}
                        className="font-poppins text-gray text-sm hover:text-primary transition-colors"
                      >
                        {item.title}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <FixedWhatsappLink />
    </footer>
  );
};

export default SiteFooter;
